import { t } from '../../../common/i18n';
import { AdditionalFeaturesContent } from './AdditionalFeaturesContent.js';
import { getDefaultCardContentData } from './ProductOfferingCardContentUtils.js';
import type { ProductCardContentProps } from './types.js';

export const getMobileVoiceCardContent = ({ productOffering }: ProductCardContentProps) => {
  const defaultData = getDefaultCardContentData(productOffering);

  return {
    subHeader: t.V15A('Elisa'),
    badges: defaultData.badges,
    infoItems: defaultData.infoItems,
    renderAdditionalContent: () => <AdditionalFeaturesContent additionalFeatures={defaultData.additionalFeatures} />,
  };
};
